import { IUserSettingsState } from './store';
import { UserSettingsActions, UserSettingsActionTypes } from './actionTypes';

export const initialUsersSettingsState: IUserSettingsState = {
  userSettings: undefined,
  accountSettings: undefined,
  isFetching: false,
  status: undefined,
};

export function userSettingsReducer(
  state = initialUsersSettingsState,
  action: UserSettingsActions
): IUserSettingsState {
  switch (action.type) {
    case UserSettingsActionTypes.FETCH_USER_SETTINGS_ERROR:
    case UserSettingsActionTypes.FETCH_ACCOUNT_SETTINGS_REQUEST:
    case UserSettingsActionTypes.FETCH_ACCOUNT_SETTINGS_ERROR:
      return {
        ...state,
        isFetching: action.isFetching,
        status: action.status,
      };
    case UserSettingsActionTypes.FETCH_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        status: action.status,
        userSettings: action.userSettings,
      };
    case UserSettingsActionTypes.FETCH_ACCOUNT_SETTINGS_SUCCESS:
      return {
        ...state,
        isFetching: action.isFetching,
        status: action.status,
        accountSettings: action.accountSettings,
      };

    default:
      return state;
  }
}
